import {
    FETCH_ADMIN_SERIE_EDIT_REQUEST,
    FETCH_ADMIN_SERIE_EDIT_SUCCESS,
    FETCH_ADMIN_SERIE_EDIT_FAILURE,
  } from "./actionTypes";
  
  import { AdminSerieEditActions, AdminSerieEditState } from "./types";
  
  const initialState: AdminSerieEditState = {
    loading: false,
    result: null,
    error: null,
  };
  
  export default (state = initialState, action: AdminSerieEditActions) => {
    switch (action.type) {
      case FETCH_ADMIN_SERIE_EDIT_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };
      case FETCH_ADMIN_SERIE_EDIT_SUCCESS:
        return {
          ...state,
          loading: false,
          result: action.payload.result,
          error: null,
        };
      case FETCH_ADMIN_SERIE_EDIT_FAILURE:
        return {
          ...state,
          loading: false,
          result: [],
          error: action.payload.error,
        };
      default:
        return {
          ...state,
        };
    }
  };